import {AbstractApiRequestInterceptor} from 'core/abstract/AbstractApiRequestInterceptor';
import {TRequestParameters} from 'core/types';

export class MixHeaderRequestInterceptor extends AbstractApiRequestInterceptor {
    public intercept(request: TRequestParameters<RequestInit, Body>): TRequestParameters<RequestInit, Body> {
        const {body, options, url} = request;

        return {
            body,
            options: {
                ...options,
                headers: {
                    ...(options?.headers ?? {}),
                    Accept: 'application/json',
                    ['Content-Type']: 'application/json',
                },
            },
            url,
        };
    }
}
